import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Wrapper from './style';
import { Input, Button, message, Icon } from 'antd';
import { identifyEmail } from '../../common/fetch';

class RecoverAccount extends Component {
	state = {
		email: '',
		step: 1,
		num: parseInt((Math.random() * 100) % 11, 10) + 1
	};

	handleChange = (e) => {
		const { name, value } = e.target;
		this.setState({
			[name]: value
		});
	};

	static getDerivedStateFromProps(props, state) {
		const isSignup = props.location && props.location.state && props.location.state.isSignup
		if (isSignup) {
			return { step: 2 };
		}
		return null
	}

	submit = async () => {
		const { email } = this.state;
		if (email === '') return;
		try {
			await identifyEmail(email);
			message.success('Check your email to confirm');
			this.setState({
				step: 2
			});
		} catch (error) {
			console.error(error);
			message.error('Error : ' + error.data.message);
		}
	};

	render() {
		const { email, step } = this.state;
		const isSignup = this.props.location && this.props.location.state && this.props.location.state.isSignup

		if (step === 1) {
			return (
				<Wrapper>
					<div className="form-box">
						<h2>Password Reset</h2>

						<Input
							prefix={
								<Icon
									type="mail"
									style={{ color: '#42454D' }}
								/>
							}
							placeholder="Email"
							name="email"
							value={email}
							onChange={this.handleChange}
							autoComplete="false"
						/>
						<div className="btn-area">
							<Button type="primary" block onClick={this.submit}>
								Get Reset Link
							</Button>
						</div>
						<div className="link">
							<Link to="/login">Go to the login page</Link>
						</div>
					</div>
				</Wrapper>
			);
		}
		return (
			<Wrapper>
				<div className="form-box">
					{isSignup ? (
						<h2>Email confirmation sent</h2>
					) : (
						<h2>
							Password Reset
							<br /> Request Submitted
						</h2>
					)}
					<div className="instructions">
						{isSignup
							? 'An email was sent to your address. Please check your email and click confirm.'
							: 'Instructions on how to reset your password will be sent if your information supplied matches our records.'}
					</div>

					<div className="link">
						<Link to="/login">Go to the login page</Link>
					</div>
				</div>
			</Wrapper>
		);
	}
}

export default RecoverAccount;
